var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeBolts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 59.893 401.199 L 45.168 401.199 L 59.893 288.102 L 8.354 288.102 C -0.186 288.102 -0.04 282.932 2.759 277.439 C 5.557 271.946 3.496 276.146 3.789 275.5 C 22.785 238.663 51.353 183.731 89.344 110.379 L 104.068 110.379 L 89.344 223.476 L 140.881 223.476 C 148.097 223.476 149.127 228.807 147.802 231.715 L 146.772 234.139 C 88.754 345.459 59.893 401.199 59.893 401.199 Z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235.39 398.514 L 220.665 398.514 L 235.39 285.417 L 183.851 285.417 C 175.311 285.417 175.457 280.247 178.256 274.754 C 181.054 269.261 178.993 273.461 179.286 272.815 C 198.282 235.978 226.85 181.046 264.841 107.694 L 279.565 107.694 L 264.841 220.791 L 316.378 220.791 C 323.594 220.791 324.624 226.122 323.299 229.03 L 322.269 231.454 C 264.251 342.774 235.39 398.514 235.39 398.514 Z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 409.706 398.895 L 394.981 398.895 L 409.706 285.798 L 358.167 285.798 C 349.627 285.798 349.773 280.628 352.572 275.135 C 355.37 269.642 353.309 273.842 353.602 273.196 C 372.598 236.359 401.166 181.427 439.157 108.075 L 453.881 108.075 L 439.157 221.172 L 490.694 221.172 C 497.91 221.172 498.94 226.503 497.615 229.411 L 496.585 231.835 C 438.567 343.155 409.706 398.895 409.706 398.895 Z",
    style: {
      opacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBolts);
export default __webpack_public_path__ + "static/media/ThreeBolts.6a19fde29cfdb1e0aeeeb1887040db73.svg";
export { ForwardRef as ReactComponent };